import pdfWorker from "pdfjs-dist/build/pdf.worker.js?url";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

export { Document, Page, pdfjs };
